import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const HouseOutline = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M5.625 13.125H4.375C2.99429 13.125 1.875 12.0057 1.875 10.625V6.69229C1.875 5.81808 2.33163 5.00738 3.07924 4.55428L6.20424 2.66035C7.00069 2.17767 7.99931 2.17767 8.79575 2.66035L11.9208 4.55428C12.6684 5.00738 13.125 5.81808 13.125 6.69229V10.625C13.125 12.0057 12.0057 13.125 10.625 13.125H9.375M5.625 13.125V10.625C5.625 9.58948 6.46444 8.75004 7.5 8.75004C8.53556 8.75004 9.375 9.58948 9.375 10.625V13.125M5.625 13.125H9.375" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 15 15">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { HouseOutline };